/* Progressive enhancement: product links remain usable without JavaScript. */
if (!customElements.get('mkoi-mood-filter')) {
  customElements.define('mkoi-mood-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.bound || !this.isConnected) return;
      const bar = this.querySelector('[data-ag-filterbar]');
      if (!bar) return;
      this.bound = true;
      bar.hidden = false;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-ag-filter]');
        if (!button || !this.contains(button)) return;
        const filter = button.dataset.agFilter;
        let count = 0;
        this.querySelectorAll('[data-ag-card]').forEach((card) => {
          const show = filter === 'all' || card.dataset.agGroup === filter;
          card.hidden = !show;
          if (show) count++;
        });
        this.querySelectorAll('button[data-ag-filter]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        const status = this.querySelector('[data-ag-status]');
        if (status) status.textContent = `${count} ${count === 1 ? 'product' : 'products'} shown.`;
        const empty = this.querySelector('[data-ag-empty]');
        if (empty) empty.hidden = count > 0;
      });
    }
  });
}
